import JustTitle from "../recipes/just-title.js";
import DrawSite from "../recipes/draw-site";
import Markers from "../recipes/markers";
import Terrain from "../recipes/terrain";
import Contours from "../recipes/contours";
import SunTracker from "../recipes/sun-tracker";
import Sections from "../recipes/sections";

const RECIPES = [
  {
    name: "Markers",
    slug: "markers",
    icon: "map-marker-alt",
    recipe: Markers,
  },
  {
    name: "Draw Site",
    slug: "draw-site",
    icon: "drafting-compass",
    recipe: DrawSite,
  },
  { type: "hr" },
  {
    name: "3D",
    slug: "3d",
    icon: "cube",
    recipe: Terrain,
  },
  {
    name: "Site Sections",
    slug: "site-sections",
    icon: "chart-area",
    recipe: Sections,
  },
  {
    name: "Contours",
    slug: "contours",
    icon: "mountain",
    recipe: Contours,
  },
  {
    name: "Sun Tracker",
    slug: "sun-tracker",
    icon: "sun",
    recipe: SunTracker,
  }
];

const findIDBySlug = (value) => {
  for (var i = 0; i < RECIPES.length; i++) {
    if (RECIPES[i]["slug"] === value) {
      return i;
    }
  }
  return 0;
};

export { RECIPES, findIDBySlug };
